import Vue from 'vue'
import pluginValue from './api-v2'
const pluginName = '$defaultV2Api'

const plugin = {
  install(Vue) {
    window[pluginName] = pluginValue
    Vue.prototype[pluginName] = pluginValue
  },
}

Vue.use(plugin)

export default plugin

export const defaultV2Api = pluginValue
